export default __webpack_public_path__ + "static/media/Archdeacon's Jerkin of the Hallow Worlds.bd7af431.jpg";